module.exports = __webpack_public_path__ + "static/img/design.7259b2f9.png";